module.exports = __webpack_public_path__ + "img/mon_256.bf71194f.png";